import Script from 'next/script';
import {memo} from 'react';

/**
 * @description: 部分无法通过swc、babel等实现的polyfill
 * @ String.replaceAll
 */
const Polyfill = () => (
    <Script id="polyfill" strategy="beforeInteractive">
        {`
        if (!String.prototype.replaceAll) {
            String.prototype.replaceAll = function (str1, str2) {
                return this.replace(new RegExp(str1, 'g'), str2);
            };
        }
        if (!Array.prototype.findLastIndex) {
            Array.prototype.findLastIndex = function(predicate, thisArg) {
                if (this == null) {
                    throw new TypeError('Array.prototype.findLastIndex called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                const arr = Object(this);
                const len = arr.length >>> 0;
                for (let i = len - 1; i >= 0; i--) {
                    if (i in arr && predicate.call(thisArg, arr[i], i, arr)) {
                        return i;
                    }
                }
                return -1;
            };
        }
        `}
    </Script>
);

export default memo(Polyfill);
